import React from 'react';
import styled from 'styled-components';

/**
 * Movie Mayhem wordmark.
 *
 * Two-line title lockup rendered as inline SVG (not an <img src>) so the
 * text elements pick up the loaded Google Fonts, respond to styling (hover,
 * animations), and scale crisply at any size.
 *
 *   1. "MOVIE"   - stroked outline only (cream-100)
 *   2. "MAYHEM"  - solid fill (cream-100), ~1.4x the height of line 1
 *
 * The outline/fill contrast between MOVIE and MAYHEM is the brand signature.
 * Do not "fix" MOVIE to be a solid fill for consistency - that flattens the
 * visual hierarchy the poster aesthetic depends on.
 */

const Svg = styled.svg`
  display: block;
  width: 100%;
  height: auto;
  color: var(--color-cream-100); /* inherited by currentColor references */
`;

const OutlineText = styled.text`
  font-family: var(--font-display);
  font-weight: 400;
  letter-spacing: 6px;
  fill: none;
  stroke: currentColor;
  stroke-width: 4;
  paint-order: stroke;
`;

const FilledText = styled.text`
  font-family: var(--font-display);
  font-weight: 400;
  letter-spacing: 6px;
  fill: currentColor;
`;

/**
 * @param {object} props
 * @param {string} [props.className] - pass-through for layout styling
 * @param {string} [props.ariaLabel] - override the default accessible name
 */
export const Wordmark = ({ className, ariaLabel = 'Movie Mayhem' }) => {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 380"
            role="img"
            aria-label={ariaLabel}
            className={className}
        >
            <g textAnchor="middle">
                <OutlineText x="500" y="160" fontSize="160">
                    MOVIE
                </OutlineText>
                <FilledText x="500" y="340" fontSize="220">
                    MAYHEM
                </FilledText>
            </g>
        </Svg>
    );
};

export default Wordmark;
